import imgLogo from "../../../../images/logo.svg";

export default function Header(props) {
  return (
    <a href="/">
      <img style={{ margin: "20px 0 30px 40px" }} src={imgLogo} />
    </a>
  );
}
